import { Button, LoadingButton } from '@olxbr/ds-core'
import { Modal } from '@olxbr/ds-web'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const DataText = styled.span`
  font-weight: var(--font-weight-bold);
`

export const RevalidationConfirmResendCodeModal = ({
  onConfirm,
  closeModal,
  isOpen,
  isSubmitting,
  descriptionElement,
}) => {
  return (
    <Modal preventCloseOnOutsideClick open={isOpen} size="small" closeCallback={closeModal}>
      <StyledFlex>
        <span className="typo-title-small mb-3">Reenviar código</span>
        {descriptionElement}
        <LoadingButton
          onClick={onConfirm}
          className="w-full mb-1 mt-1"
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          Reenviar
        </LoadingButton>
        <Button variant="link" className="w-full" onClick={closeModal} disabled={isSubmitting}>
          Cancelar
        </Button>
      </StyledFlex>
    </Modal>
  )
}

RevalidationConfirmResendCodeModal.propTypes = {
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  closeModal: PropTypes.func,
  descriptionElement: PropTypes.node,
}
